"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationCodeInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _VerifyStyled = require("./VerifyStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const VerificationCodeInput = props => {
  const {
    index,
    inputRef,
    handleInput,
    handleDelete,
    handleSubmit,
    handlePaste,
    hasError
  } = props;
  const verificationInputRef = (0, _react.useRef)(null);
  const onSetInputRef = instance => {
    verificationInputRef.current = instance;
    inputRef(instance, index);
  };
  const handleVerificationInput = async e => {
    // eslint-disable-next-line no-param-reassign -- needs to reassign e.target
    e.target.value = e.target.value.replaceAll(/\D/g, '');
    if (e.target.value) {
      await handleInput(index);
    }
  };
  const handleFocus = () => {
    if (verificationInputRef.current) {
      verificationInputRef.current.select();
    }
  };
  const handleKeyDown = async event => {
    if (!verificationInputRef.current) {
      return;
    }
    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (verificationInputRef.current.value) {
        verificationInputRef.current.value = '';
      } else {
        event.preventDefault();
        handleDelete(index);
      }
    } else if (event.key === 'Enter') {
      event.preventDefault();
      await handleSubmit();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyStyled.StyledTextField, {
    type: "text",
    variant: "outlined",
    error: hasError,
    inputProps: {
      maxLength: 1,
      autoComplete: 'no-fill',
      inputMode: 'numeric'
    },
    inputRef: onSetInputRef,
    onInput: handleVerificationInput,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onPaste: handlePaste
  });
};
exports.VerificationCodeInput = VerificationCodeInput;
